import { Option } from '@sapphire/result';
import type { Country } from '@ps/core-models';

/**
 * Resolves a 2-letter translate code (e.g. "en") to the master-data 3-letter
 * short code (e.g. "eng") — some backend lookups (e.g. `pricingService`) match
 * by short code, so sending the translate code straight through fails them.
 */
export function resolveMasterLanguageCode(
  countryCode: string,
  translateCode: string,
  countries: readonly Country[],
): Option<string> {
  return Option.from(
    countries.find((country) => country.shortCode === countryCode),
  )
    .andThen((country) =>
      Option.from(
        country.language.find(
          (language) => language.translateCode === translateCode,
        ),
      ),
    )
    .map((language) => language.shortCode);
}
